import {KeycloakService} from 'keycloak-angular';
import {SessionService} from '../_shared/modules/agri-auth/state/session';
import {TokenRefreshService} from '../_shared/modules/agri-auth/services/token-refresh.service';


export function initializer(
  keycloak: KeycloakService,
  sessionService: SessionService,
  tokenRefreshService: TokenRefreshService,
): () => Promise<any> {

  const realm = window['env']['realm'];
  const url = window['env']['keycloakUrl'];
  const clientId = window['env']['clientId'];

  return () =>
    keycloak.init({
      config: {url, realm, clientId},
      initOptions: {
        onLoad: 'login-required',
        checkLoginIframe: false
      },
      loadUserProfileAtStartUp: false,
      enableBearerInterceptor: false,
      bearerExcludedUrls: []
    }).then(() => {
      const {token} = keycloak.getKeycloakInstance();

      if (!token) {
        sessionService.redirectToLogin();
        return;
      }

      sessionService.saveToken(token);
      sessionService.loadUser();
      tokenRefreshService.start();
    });
}
